import React from 'react';

import { Theme, createStyles, withStyles, Typography, Popover, Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import file from '../../../assets/excelFile.svg'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions, } from 'chart.js';
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import { Chart } from 'react-chartjs-2';
import { SCREENING_MEASURES_COLOR, SCREENING_METHOD_CODES } from '../../../utils/Analytics';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CardPadding = '12px 16px';
const useStyles = (theme: Theme) =>
  createStyles({
    root: {
      padding: CardPadding
    },
    popover: {
      pointerEvents: 'none',
      '& *': {
        fontFamily: 'Nunito',
      }
    },
    infoIcon: {
      lineHeight: 0,
    }
  });

interface SecurityMethodsProps {
  classes: any;
  report: string;
  methods: any[string];
  measure: string;
  scrExemptions: string[];
  handleExport: (type: string) => void;
};

const SecurityMethods = (props: SecurityMethodsProps) => {

  const { classes } = props;

  const data = {
    labels: props.scrExemptions.map((l: string) => {
      if (SCREENING_METHOD_CODES[l]) {
        return SCREENING_METHOD_CODES[l].code;
      } else {
        return l;
      }
    }),
    datasets: [
      {
        barPercentage: 0.5,
        data: props.scrExemptions.map((e: string) => {
          if (props.methods[props.measure + e]) {
            return props.methods[props.measure + e]
          } else {
            return 0;
          }
        }),
        backgroundColor: SCREENING_MEASURES_COLOR[props.measure] || '#000'
      },
    ],
  };

  const graphOptions: ChartOptions = {
    plugins: {
      legend: {
        fullSize: true,
        display: false,
      },
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            if (typeof data == 'number')
              sum += data;
          });
          let result = value * 100 / sum
          let percentage = (result).toFixed(0) + "%";
          if (result > 0) {
            return percentage;
          } else {
            return '';
          }
        },
        color: '#fff',
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
        },
      },
      y: {
        title: {
          display: true,
          text: props.report == 'pcs' ? 'Pieces' : props.report == 'wgt' ? 'Weight' : 'Air Way Bills'
        }
      }
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
    document.body.classList.add(commonStyles.pr24)
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    document.body.classList.remove(commonStyles.pr24)
  };

  const open = Boolean(anchorEl);

  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap}`}>
        <div className={`${commonStyles.fvMiddle} ${commonStyles.gap10}`}>
          <Typography
            component='div'
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            className={classes.infoIcon}
          >
            <Info color='primary' />
          </Typography>
          <h5 className={styles.heading}> {props.measure == 'Screened' ? 'Screening Methods' : (props.measure ? props.measure + 's' : 'Security Screening methods')}</h5>
        </div>
        <div className={`${styles.fileImg}`} onClick={() => props.handleExport('methods')}>
          <img src={file} alt="file" />
        </div>
      </div>
      <div className={styles.graphWrapper}>
        <div className={styles.barWrapper}>
          <Chart type={'bar'} height={300} data={data} options={graphOptions} />
        </div>
      </div>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Card>
          <CardHeader
            title={<Typography variant="body2">
              {props.measure == 'Screened' ? 'Screening Methods' : (props.measure ? props.measure + 's' : 'Security Screening methods')} Legend
            </Typography>}
            classes={{ root: classes.root }}
          >
          </CardHeader>
          <Divider />
          <CardContent classes={{ root: classes.root }}>
            {
              props.scrExemptions.map((e: string) => {
                return (
                  <Typography variant="body2" gutterBottom color="textSecondary" component="p">
                    {SCREENING_METHOD_CODES[e] ? SCREENING_METHOD_CODES[e].code : e} = {SCREENING_METHOD_CODES[e] ? SCREENING_METHOD_CODES[e].text : e}
                  </Typography>
                )
              })
            }
          </CardContent>
        </Card>
      </Popover>
    </div>
  );
};

export default withStyles(useStyles)(SecurityMethods);

